'use strict';

angular.module('atex.dam').directive('damSendContent', function($compile,$http,$modal,$q,ContentService,DamMarkAsService,DamNotificationService, $translate, $window) {
  return {
    restrict: 'ACE',
    templateUrl: 'views/dam-send-content.html',
    replace: true,
    scope: {
      showlabel: "=",
      entries: "=",
      buttonEnabled: "="
    },
    link: function (scope, element, attrs) {
      scope.$watch('entries', function (values, oldValues) {
        if (values !== oldValues && values.length > 0) {
          scope.init();
        }
      }, true);

      scope.init = function () {
        scope.rules = DamMarkAsService.getSendContentRules();
        scope.action = _.find(scope.rules, function (configuration) {
          return (configuration.defaultAction === "true");
        });
      };

      scope.show = false;
      scope.init();

      scope.error = function () {
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: $translate.getTranslationTable().__NO_DEFAULT_OPERATION__}), true);
      };

      scope.sendcontent = _.debounce( function (ruleId) {
        var idlist = [];
        scope.show = true;
        for (var i = 0; i < scope.entries.length; i++) {
          idlist.push(scope.entries[i].id);
        }
        var selected = void 0;
        scope.rules.forEach(function (rule) {
          if (rule.id === Number(ruleId)) {
            selected = rule;
          }
        });
        $window.atex.analytics('event', { e: 'sendContent', d1: selected.name, d2: idlist });
        if (selected.protocol.lastIndexOf("smtp") === 0) {
          scope.createModal(ruleId, idlist, selected.toAddress).then(function (cancelled) {
            if (!cancelled) {
              scope.show = false;
            }
          });
        } else {
          scope.send(ruleId, idlist, undefined);
        }
      }, 1000, true);

      scope.createModal = function (ruleId, idlist, toAddress) {
        var templateScope = scope.$root.$new(true);
        templateScope.toAddress = toAddress;
        templateScope.senderScope = scope;
        templateScope.idlist = idlist;
        templateScope.ruleId = ruleId;
        templateScope.rule = scope.rules[ruleId];

        var modal = $modal({
          show: true,
          scope: templateScope,
          template: 'views/dam-mail-modal.html',
          modalClass: 'dam-modal-edit confirm-modal ng-cloak',
          backdrop: 'static',
          keyboard: false
        });

        templateScope.verified = (templateScope.confirm !== true);
        var deferred = $q.defer();

        var destroyModal = function () {
          modal.then(function (modalEl) {
            modalEl.on('hidden.bs.modal', function () {
              templateScope.$destroy();
              angular.element(this).remove();
            });
            modalEl.modal('hide');
          });
        };

        templateScope.doCancel = function () {
          destroyModal();
          deferred.resolve(false);
        };

        return deferred.promise;
      };

      scope.send = function (ruleId, idlist, mail, useSystemUsers) {
        if (mail === undefined) {
          mail = {};
          mail.body = "";
          mail.subject = "";
        }

        var data = {
          'aspects': {
            'contentData': {
              'data': {
                '_type': 'com.atex.onecms.app.dam.sendcontent.DamSendContentRequest',
                'id': JSON.parse(JSON.stringify(idlist)),
                'ruleId': ruleId,
                'subject': mail.subject,
                'body': mail.body,
                'to': mail.to,
                'sendEmail' : mail.sendEmail
              }
            }
          }
        };
        var url;
        var method;
        if (useSystemUsers) {
          url = "/onecms/dam/content/assigncontent";
          method = $http.post;

        } else {
          url = "/onecms/dam/content/sendcontent";
          method = $http.put;
        }
        method(url, data).then(function successCallback(response) {
          scope.show = false;
          DamNotificationService.addNotification(atex.dam.Notification({type: 'success', message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__}), false);
        }, function errorCallback(response) {
          scope.show = false;
          var message = $translate.getTranslationTable().__ERROR_DURING_SEND_CONTENT__;

          if (response.data && response.data.message && response.data.message.length > 0) {
            message += ":<br/>" + response.data.message;
          } else if (response.statusText && response.statusText.length > 0) {
            message += ":<br/>" + response.statusText;
          }

          DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
        });

      };
    }
  };
});